import { ProductKeys } from '../../../common/constants/product-keys';
import { type ThirdPartyConfigsBootstrap } from '../../../common/constants/schemas/3p-config';
import { useShouldSuppressBannerForAnimation } from '../../../common/utils/quick-find/use-suppress-banner-for-animation';
import { useBannerEligibleProductsOrder } from '../../3p-smart-link-usage';
import {
	useAvailableProducts,
	usePrimaryProduct,
	useThirdPartyConfigs,
} from '../../store/bootstrap';

type QuickFindBannerPlacementConfig = {
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
	bannerEligibleProductsOrder: ProductKeys[];
	shouldMountPlacement: boolean;
};

export const useQuickFindBannerPlacementConfig = (
	isInteracted?: boolean,
): QuickFindBannerPlacementConfig => {
	const [thirdPartyConfigs] = useThirdPartyConfigs();
	const availableProducts = useAvailableProducts();
	const [primaryProduct] = usePrimaryProduct();
	// In Jira, the quick find component is already rendered on hover, so isInteracted is not needed.
	const isJira = primaryProduct === ProductKeys.Jira;

	const bannerEligibleProductsOrder = useBannerEligibleProductsOrder({
		isOnSearchDialog: true,
		thirdPartyConfigs,
		availableProducts,
	});

	const suppressBanner = useShouldSuppressBannerForAnimation();
	const hasBannerEligibleProducts = bannerEligibleProductsOrder.length > 0;
	const shouldMountPlacement =
		hasBannerEligibleProducts && (isInteracted || isJira) && !suppressBanner;

	return {
		thirdPartyConfigs,
		bannerEligibleProductsOrder,
		shouldMountPlacement,
	};
};
